function AdminProgressbar() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Progress Overview</h1>
        <p className="text-gray-600">Track your learning progress and achievements</p>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-gray-600">Progress tracking will be implemented here.</p>
        </div>
      </div>
    </div>
  )
}

export default AdminProgressbar